import { withSvgIcon } from './withSvgIcon';

export const ArrowLeftSmall = withSvgIcon(
  <path
    d="M11 17L6 12M6 12L11 7M6 12L17 12"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="square"
    strokeLinejoin="round"
  />,
  { viewBox: '0 0 24 24' },
);
